// FAQs.js
import React, { useState } from 'react';
import './faqs.css';

const faqs = [
    {
      question: "What is Diyatharippu - International Optometric Conference?",
      answer: "Diyatharippu is a global conference bringing together experts in optometry and vision science to discuss the latest advancements and research."
    },
    {
      question: "When and where will the conference take place?",
      answer: "The conference will be held on 24th, 25th and 26th @ Monarch Imperial Hotel, Colombo. Inauguration is on 24th and 25th and 26th are the conference days."
    },

    {
      question: "Who can attend the conference?",
      answer: "The conference is open to optometrists, vision scientists, students, researchers, and professionals interested in eye care and optometry."
    },
    {
      question: "How can I register for the 1st international conference in Sri Lanka?",
      answer: "You can register through our official website. Early bird registrations are available."
    },
  {
      question: "Conference Program",
      answer: "The conference will feature a variety of sessions, workshops, and keynote speeches from leading experts in the field."
    },
    {
      question: "Will there be online participation options?",
      answer: "More details will be updated soon."
    }
  ];

function FAQs() {
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="faqs-container">
      <h2 className="faqs-title">Frequently Asked Questions</h2>
      <div>
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeFaq === index ? 'active' : ''}`}
          >
            <div
              className="faq-question"
              onClick={() => toggleFaq(index)}
            >
              {faq.question}
            </div>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQs;